import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  OnInit,
  Renderer2,
  ViewChild,
} from '@angular/core';
import { ModalController } from '@ionic/angular';
import { animate, keyframes, transition, trigger } from '@angular/animations';
import { FeatureShowcaseComponent } from 'src/app/components/feature-showcase/feature-showcase.component';
import { LoaderModalComponent } from 'src/app/components/loader-modal/loader-modal.component';
import { ApiService } from 'src/app/services/API/api.service';
import { EventService } from 'src/app/services/Events/events.service';
import {
  ANIMATION_TIMER,
  GlobalService,
} from 'src/app/services/global/global.service';
import { WidgetsService } from 'src/app/services/ui/widgets.service';
import { environment } from 'src/environments/environment';
import { decode } from 'ee-crypto-encode-decode';
import { CachingService } from 'src/app/services/cache/caching.service';
import * as kf from 'src/app/utils/keyframes';
declare const ONE3D: any;
declare const window: any;

@Component({
  selector: 'one3d',
  templateUrl: './one3d.component.html',
  styleUrls: ['./one3d.component.scss'],
  animations: [
    trigger('cardAnimator', [
      transition(
        '* => slideOutUp',
        animate(ANIMATION_TIMER, keyframes(kf.slideOutUp))
      ),
      transition(
        '* => slideInDown',
        animate(ANIMATION_TIMER, keyframes(kf.slideInDown))
      ),
    ]),
  ],
})
export class One3dComponent implements OnInit {
  isFeaturePlaying: boolean;
  featureUrl: any;
  featureType: any;
  @ViewChild('one3d_video', { static: false }) one3d_video: ElementRef;
  @ViewChild('one3dCanvasContainer')
  one3dCanvasContainer: ElementRef<HTMLElement>;
  cameraSetToAccessory = false;
  showImageAccessory = false;
  accessoryImageUrl = '';
  imageLoaded = false;
  pathToAssets = environment.assetsUrl;
  startTime: any;
  loadedPercent = 0;
  isFeatureLoading = false;
  primaryColor = '#28A420';

  constructor(
    private events: EventService,
    private widgetService: WidgetsService,
    public globalService: GlobalService,
    private modalController: ModalController,
    private apiService: ApiService,
    private changeDetector: ChangeDetectorRef,
    private cachingService: CachingService,
    private renderer: Renderer2
  ) {
    window.onInteriorViewComplete = () => {
      this.events.publish('events', { view: { id: 'INT_COMPLETE' } });
      this.events.publish('events', { showColors: true });
      setTimeout(() => {
        this.widgetService.hideLoader();
      }, 500);
      if (this.cameraSetToAccessory) {
        this.events.publish('events', { resetToDefault: null });
      }
      this.apiService.sendReportingData({
        eName: 'explore',
        eCat: 'car_config_page',
        eAct: 'interior_explore',
      });
    };

    window.onExteriorViewComplete = () => {
      this.events.publish('events', { view: { id: 'EXT_COMPLETE' } });
      setTimeout(() => {
        this.widgetService.hideLoader();
      }, 500);
      if (this.cameraSetToAccessory) {
        this.events.publish('events', { resetToDefault: null });
      }
      this.apiService.sendReportingData({
        eName: 'explore',
        eCat: 'car_config_page',
        eAct: 'exterior_explore',
      });
    };
    window.addEventListener('resize', function () {
      if (typeof ONE3D !== 'undefined' && ONE3D?.hasOwnProperty('event')) {
        setTimeout(() => {
          this.events?.publish('events', {
            resize: null,
          });
        }, 100);
      }
    });
    window.getLoaderProgress = (data) => {
      this.events.publish('events', { carLoadPercent: data });
    };

    window.enableFeatureButtons = () => {
      // setTimeout(() => {
      //   this.events.publish('playNext', { playNext: null });
      // }, 2000);
      // ONE3D.exitFeatureView();
    };
    window.frontSeatViewComplete = () => {
      this.events.publish('events', {
        frontSeatViewComplete: null,
      });
    };
    window.backSeatViewComplete = () => {
      this.events.publish('events', {
        backSeatViewComplete: null,
      });
    };
    window.lastSeatViewComplete = () => {
      this.events.publish('events', {
        lastSeatViewComplete: null,
      });
    };

    window.one3dFeatureSelect = (event) => {
      this.playFeatures(event.hotspot);
    };

    const root = document.documentElement;
    this.primaryColor = getComputedStyle(root).getPropertyValue('--ion-color-primary').trim();
  }

  ngOnInit() {
    this.events.subscribe('events', (data) => {
      this.subscribeToEvents(data);
    });
  }
  ngAfterViewInit() {
    this.one3dCanvasContainer.nativeElement.addEventListener('click', () => {
      this.events.publish('events', { hideTutorial: true });
    });
    this.one3dCanvasContainer.nativeElement.addEventListener('mouseup', () => {
      this.events.publish('events', { hideTutorial: true });
    });
    this.one3dCanvasContainer.nativeElement.addEventListener(
      'mousedown',
      () => {
        this.events.publish('events', { hideTutorial: true });
      }
    );
    this.one3dCanvasContainer.nativeElement.addEventListener(
      'touchstart',
      () => {
        this.events.publish('events', { hideTutorial: true });
      }
    );
  }

  resizeWindow() {
    if (ONE3D?.hasOwnProperty('event')) {
      ONE3D.event.onResizeWindow();
    } else if (ONE3D?.onResizeWindow) {
      ONE3D.onResizeWindow();
    } else {
      // 'No onResizeWindow exists'
    }
  }

  async load3d(defaultVariant) {
    let addedTrim;
    let defaultPackLoaded: any = this.getDefaultPack(defaultVariant);
    let meshCodes = this.getAddedMesh(defaultVariant);

    // logic for loading car with stored trim data
    if (this.globalService.trim_color_id && defaultVariant.trims.length > 0) {
      addedTrim = defaultVariant.trims.filter((el) => {
        return el.variant_color_id == this.globalService.trim_color_id;
      })[0];
    } else if (defaultVariant.trims.length > 0) {
      addedTrim = defaultVariant.trims.filter((el) => {
        return el.is_default == 'yes';
      })[0];
    } else {
      // 'no trims & load variant_3d_code'
    }

    this.apiService.logGAEvent('uaevent', 'Content', 'Loader', 'Start');
    this.apiService.logGAEvent(
      'uaevent',
      'Content',
      'Loader::Set_' + this.globalService.idea,
      'Start::Set_' + this.globalService.idea
    );
    // Get the start time
    this.startTime = performance.now();
    this.apiService.sendReportingData({
      eName: 'internal',
      eCat: 'car_config_page',
      eAct: '3d_model_loading',
      eVal: 'start',
    });
    sessionStorage.setItem('defaultPackLoaded', defaultPackLoaded);
    ONE3D.init(
      'one3d',
      this.pathToAssets + 'one3d/',
      defaultVariant.model_name,
      addedTrim ? addedTrim.color_3d_code : defaultVariant.variant_3d_code,
      {
        showFeature: true,
        showFeatureHp: !this.globalService.isConfiguratorActive(),
        loadPNG: false,
        showDefaultLoader: false,
        callback: () => {
          this.firstLoadComplete(defaultVariant);
          setTimeout(() => {
            this.resizeWindow();
          }, 1000);
        },
        onProgress: (data) => {
          if (this.loadedPercent < data) {
            this.loadedPercent = data;
            window.getLoaderProgress(data);
          }
        },
        preConfig: meshCodes,
        pack: defaultPackLoaded ? defaultPackLoaded : null,
      }
    );
  }

  getAddedMesh(defaultVariant) {
    let meshCodes = [];
    let addedAccessories = this.globalService.addedAccessories;
    let addedAccessoriesPacks = this.globalService.addedAccessoriesPacks;
    let defaultPackLoaded: any = this.getDefaultPack(defaultVariant);

    for (let index = 0; index < addedAccessories.length; index++) {
      if (addedAccessories[index].mesh_code) {
        meshCodes.push(addedAccessories[index].mesh_code);
      } else {
        // 'mesh_code not available'
      }
    }
    // default pack logic with kits in acc section
    if (!defaultPackLoaded) {
      for (let index = 0; index < addedAccessoriesPacks.length; index++) {
        for (
          let j = 0;
          j < addedAccessoriesPacks[index].accessoriesList.length;
          j++
        ) {
          if (addedAccessoriesPacks[index].accessoriesList[j].mesh_code) {
            meshCodes.push(
              addedAccessoriesPacks[index].accessoriesList[j].mesh_code
            );
          }
        }
      }
    }

    //  variant load with default accessories
    if (defaultVariant?.default_pack?.length > 0) {
      meshCodes.push(...defaultVariant.default_pack);
    } else {
      // 'no default acc with variant'
    }

    return meshCodes;
  }

  async openLoaderModal() {
    const modal = await this.modalController.create({
      component: LoaderModalComponent,
      cssClass: 'one-3d-full-page-modal',
      backdropDismiss: false,
      animated: false,
    });

    await modal.present();
  }
  async changeVariant(selectedVariant) {
    let defaultPackLoaded = this.getDefaultPack(selectedVariant);
    this.widgetService.showLoaderWithText(this.globalService.model?.model_name);
    let meshCodes = [];

    //  variant load with default accessories
    if (selectedVariant?.default_pack?.length > 0) {
      meshCodes.push(...selectedVariant.default_pack);
    } else {
      // 'no default acc with variant'
    }

    ONE3D.changeVariant(selectedVariant.variant_3d_code, {
      callback: (e) => {
        this.variantLoadComplete(selectedVariant);
        this.events.publish('events', { resetToDefault: null });
      },
      showFeature: true,
      showFeatureHp: true,
      pack: defaultPackLoaded ? defaultPackLoaded : null,
      preConfig: meshCodes,
    });
  }
  loadCarComplete() {
    this.widgetService.hideLoader();
  }
  async intFromHotspot() {
    ONE3D.exteriorView();
    window.dataLayer.push({
      event: 'uaevent',
      eventCategory: 'Content',
      eventAction: 'Click::Hotspots',
      eventLabel: 'Exterior',
    });
    let p = await sessionStorage.getItem('pin_no');
    let pin = decode(JSON.parse(p));
    let request = {
      pin_no: pin?.[this.globalService?.vehicleCode] ?? '',
      col_name: 'exterior_hp',
      col_value: 'Yes',
    };
    const token = sessionStorage.getItem('access-token');
    fetch(
      environment.apiUrl + 'api/v1/configuration/visualizer/save-analytics',
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: 'Bearer ' + token,
        },
        body: JSON.stringify(request),
      }
    ).then(() => { });
  }
  async extFromHotspot() {
    ONE3D.interiorView();
    window.dataLayer.push({
      event: 'uaevent',
      eventCategory: 'Content',
      eventAction: 'Click::Hotspots',
      eventLabel: 'Interior',
    });
    let p = await sessionStorage.getItem('pin_no');
    let pin = decode(JSON.parse(p));
    let request = {
      pin_no: pin?.[this.globalService?.vehicleCode] ?? '',
      col_name: 'interior_hp',
      col_value: 'Yes',
    };
    const token = sessionStorage.getItem('access-token');
    fetch(
      environment.apiUrl + 'api/v1/configuration/visualizer/save-analytics',
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: 'Bearer ' + token,
        },
        body: JSON.stringify(request),
      }
    ).then(() => { });
  }
  firstLoadComplete(defaultVariant) {
    if (this.globalService.configurator) {
      if (ONE3D && ONE3D.toggleHotspot && typeof ONE3D.toggleHotspot === 'function') {
        ONE3D.toggleHotspot(false);
      }
    } else {
      // if visualizer then hide only accessories added, not default pack acc
      let meshCodes = defaultVariant.default_pack?.length
        ? defaultVariant.default_pack
        : [];
      ONE3D.hideAddedAccessories({ excludes: meshCodes });
    }
    const endTime = performance.now();
    // Calculate the time taken in seconds
    const timeTakenInSeconds = Math.floor((endTime - this.startTime) / 1000);
    this.apiService.logGAEvent('uaevent', 'Content', 'Loader', 'End');
    this.apiService.logGAEvent(
      'uaevent',
      'Content',
      'Loader::Set_' + this.globalService.idea,
      'End::Set_' + this.globalService.idea
    );
    this.apiService.logGAEvent(
      'uaevent',
      'Content',
      'Load_Time_in_sec',
      timeTakenInSeconds
    );
    this.apiService.logGAEvent(
      'uaevent',
      'Content',
      'Load_Time_in_sec::Set_' + this.globalService.idea,
      timeTakenInSeconds
    );
    this.apiService.sendReportingData({
      eName: 'internal',
      eCat: 'car_config_page',
      eAct: '3d_model_loading',
      eVal: 'stop',
    });
    let opt = {
      interior: this.intFromHotspot,
      exterior: this.extFromHotspot,
    };
    if (ONE3D && ONE3D?.event) {
      ONE3D.event.registerClickAction(opt);
    }
    this.events.publish('events', { firstLoadComplete: defaultVariant });
  }
  variantLoadComplete(selectedVariant) {
    this.widgetService.hideLoader();
    this.events.publish('events', { variantLoadComplete: null });
  }
  subscribeToEvents(data) {
    let key = Object.keys(data)[0];
    switch (key) {
      case 'startCarLoading':
        this.injectAssetsToDOM(data[key]);
        break;
      case 'selectedVariant':
        this.events.publish('events', { variantLoadStart: null });
        let selectedVariant = data.selectedVariant;
        this.changeVariant(selectedVariant);
        break;
      case 'selectedColor':
        let selectedColor = data.selectedColor;
        ONE3D.changeColor(selectedColor.color_3d_code);
        break;
      case 'selectedTrim':
        let selectedTrim = data.selectedTrim;
        this.widgetService.showLoader();
        let addedMeshCodes = this.getAddedMesh(
          this.globalService.selectedVariant
        );
        ONE3D.changeVariant(selectedTrim.color_3d_code, {
          callback: (e) => {
            this.trimLoadComplete();
            this.widgetService.hideLoader();
          },
          showFeature: true,
          showFeatureHp: true,
          preConfig: addedMeshCodes,
        });
        break;
      case 'toggleSunroof':
        this.events.publish('events', { sunroofStart: null });
        ONE3D.toggleSunroof({
          callback: (e) => {
            this.events.publish('events', { sunroofEnd: null });
          },
        });
        break;
      case 'toggleSunroofQuick':
        this.quickSunroofClose();
        break;
      case 'toggleDoorQuick':
        this.quickDoorClose();
        break;
      case 'toggleLights':
        this.events.publish('events', { lightStart: null });
        ONE3D.toggleLights({
          callback: (e) => {
            this.events.publish('events', { lightEnd: null });
          },
        });
        break;

      case 'toggleDoors':
        this.events.publish('events', { doorStart: null });
        ONE3D.toggleDoors().then(() => {
          this.events.publish('events', { doorEnd: null });
        });
        break;

      case 'backgroundChange':
        switch (data.backgroundChange.env) {
          case 'night':
            this.widgetService.showLoaderWithText(
              this.globalService.model?.model_name
            );
            ONE3D.ChangeEnv('night', {
              callback: () => {
                this.widgetService.hideLoader();
              },
            });
            break;
          case 'day':
            this.widgetService.showLoaderWithText(
              this.globalService.model?.model_name
            );
            ONE3D.ChangeEnv('day', {
              callback: () => {
                this.widgetService.hideLoader();
              },
            });
            break;
          default:
            break;
        }
        break;

      case 'view':
        switch (data.view.id) {
          case 'INT':
            // if (window.untouched == true) {
            //   window.removecameratutorial();
            // }
            this.closeImagePopup();
            this.widgetService.showLoader();
            ONE3D.interiorView();
            break;
          case 'EXT':
            this.closeImagePopup();
            this.widgetService.showLoader();
            ONE3D.exteriorView();
            break;
          case 'SEAT':
            if (data.view.value == 'frontSeatView') ONE3D.frontseatView();
            else if (data.view.value == 'backSeatView') ONE3D.backseatView();
            else if (data.view.value == 'lastSeatView') ONE3D.lastseatView();
            break;
          default:
            break;
        }
        break;

      case 'resize':
        setTimeout(() => {
          this.resizeWindow();
        }, 100);
        break;

      case 'featureDetails':
        this.isFeatureLoading = true;
        setTimeout(() => {
          this.resizeWindow();
        }, 100);
        // if (window.untouched == true) {
        //   window.removecameratutorial();
        // }

        let featureDetails = data.featureDetails;
        if (featureDetails) {
          var { hotspot_name, feature_type, feature_url } = featureDetails;
          // this.featureType = feature_type;
          // this.featureUrl = feature_url;
        }

        switch (feature_type) {
          case '3D':
            this.events.publish('events', { featureIsPlaying: true });
            ONE3D.playFeature(hotspot_name);
            this.isFeatureLoading = false;
            setTimeout(() => {
              this.featureType = feature_type;
              this.featureUrl = feature_url;
              setTimeout(() => {
                this.resizeWindow();
              }, 100);
            }, 500);
            setTimeout(() => {
              this.events.publish('events', { featureIsPlaying: false });
            }, 2000);
            break;

          case '2D_Image':
            ONE3D.exitFeatureView();
            this.featureType = feature_type;
            this.featureUrl = feature_url;
            this.events.publish('events', { featureIsPlaying: false });
            this.events.publish('events', { featureIsImage: false });
            // setTimeout(() => {
            //   this.events.publish('playNext', { playNext: null });
            // }, 10000);
            break;

          case '2D_Video':
            ONE3D.exitFeatureView();
            this.featureType = feature_type;
            this.featureUrl = feature_url;
            this.changeDetector.detectChanges();
            let video: any = document.getElementById('one3d_video');
            let source: any = document.getElementById('one3d_source');
            source.setAttribute('src', this.featureUrl);
            video.load();
            video.play().catch(error => console.log('Video play error:', error));
            this.changeDetector.detectChanges();
            this.events.publish('events', { featureIsPlaying: true });
            this.events.publish('events', { featureIs2Dvideo: false });

            setTimeout(() => {
              this.events.publish('events', { featureIsPlaying: false });
            }, 2000);

            // setTimeout(() => {
            //   this.one3d_video.nativeElement.onended = () => {
            //     this.events.publish('playNext', { playNext: null });
            //   };
            // }, 10);

            break;
          default:
            this.featureType = '3D';
            break;
        }
        break;
      case 'addAccessory':
        this.addAccessory(data.addAccessory);
        break;
      case 'removeAccessory':
        this.removeAccessory(data.removeAccessory);
        break;
      case 'removeAccessoryFromSummary':
        this.removeAccessory(data.removeAccessoryFromSummary, 'fromSummary');
        break;
      case 'removeAccessoryForPack':
        this.removeAccessoryForPackOverlap(data.removeAccessoryForPack);
        break;
      case 'addImageAccessory':
        this.addImageAccessory(data.addImageAccessory);
        break;
      case 'removeImageAccessory':
        this.removeImageAccessory(data.removeImageAccessory);
        break;
      case 'addPack':
        this.addPack(data.addPack);
        this.events.publish('events', { resetToDefault: null });
        break;
      case 'removePack':
        this.removePack(data.removePack);
        this.events.publish('events', { resetToDefault: null });
        break;
      case 'view3DAccessory':
        this.view3DAccessory(data.view3DAccessory);
        break;
      case 'resetToDefault':
        this.resetToDefaultPosition();
        break;
      case 'removeTutorial':
        // setTimeout(() => {
        //   window.removecameratutorial();
        // }, 500);
        break;
      case 'closeFeatureShowCase':
        this.isFeatureLoading = false;
        ONE3D.exitFeatureView();
        break;
      case 'loadOldConfiguration':
        this.loadOldConfiguration(data.loadOldConfiguration);
        break;
      case 'newConfiguration':
        this.changeVariant(data.newConfiguration);
        break;
      case 'navigateToConfigure':
        if (ONE3D && ONE3D.toggleHotspot && typeof ONE3D.toggleHotspot === 'function') {
          ONE3D.toggleHotspot(false); // hide feature hotspot
          }
        ONE3D.showAddedAccessories(); // show added accessories
        break;
      case 'backToVisualizer':
        if (ONE3D && ONE3D.toggleHotspot && typeof ONE3D.toggleHotspot === 'function') {
          ONE3D.toggleHotspot(true); // show feature hotspot
          }
        // if visualizer then hide only accessories added, not default pack acc
        let meshCodes = this.globalService.selectedVariant.default_pack?.length
          ? this.globalService.selectedVariant.default_pack
          : [];
        ONE3D.hideAddedAccessories({ excludes: meshCodes }); // hide added accessories
        break;
      case 'variantLoadComplete':
        if (this.globalService.configurator) {
          setTimeout(() => {
            if (ONE3D && ONE3D.toggleHotspot && typeof ONE3D.toggleHotspot === 'function') {
              ONE3D.toggleHotspot(false);
              }
          }, 100);
        } else {
          // 'variantLoadComplete toggleHotspot else'
        }
        break;
      case 'fullscreen':
        if (ONE3D?.fullscreen) {
          ONE3D.fullscreen(data.fullscreen);
        } else {
          // 'no fullscreen func'
        }
        break;
      default:
        break;
    }
  }

  resetToDefaultPosition() {
    // exit acc view only if camera set to acc view
    if (this.cameraSetToAccessory) {
      if (this.globalService.viewInterior) {
        ONE3D.exitAccessoriesView('Interior');
      } else {
        ONE3D.exitAccessoriesView('Exterior');
      }
      this.cameraSetToAccessory = false;
    } else {
      this.cameraSetToAccessory = false;
    }

    this.showImageAccessory = false;
    this.imageLoaded = false;
    this.globalService.imageAccessoryOpen = false;
    this.accessoryImageUrl = null;
    this.events.publish('events', { accessoryShowTutorial: true });
  }

  addAccessory(accessory) {
    // if (window.untouched) {
    // setTimeout(() => {
    //   window.removecameratutorial();
    // }, 500);
    // }
    if (this.showImageAccessory) {
      this.showImageAccessory = false;
    }
    this.globalService.imageAccessoryOpen = false;
    this.events.publish('events', { accessoryLoading: null });
    ONE3D.setAccessorieCamera(accessory.hotspot_name, null, {
      // Set camera Angle
      callback: () => {
        // Add Accessories
        this.cameraSetToAccessory = true;
        ONE3D.addAccessorie(accessory.mesh_code, accessory.tag_name, {
          // Add Accessories
          callback: () => {
            if (ONE3D?.hasOwnProperty('event')) {
              ONE3D.event.setMeshEnable(accessory.mesh_code, true);
            } else {
              // 'no setMeshEnable'
            }
            this.events.publish('events', { accessoryLoadingComplete: null });
          },
        })?.then(() => {
          if (ONE3D?.hasOwnProperty('event')) {
            ONE3D.event.setMeshEnable(accessory.mesh_code, true);
          } else {
            // 'no setMeshEnable'
          }
          this.events.publish('events', { accessoryLoadingComplete: null });
        });
      },
    });
  }

  addPack(pack) {
    this.events.publish('events', { accessoryLoading: null });
    // setTimeout(() => {
    //   window.removecameratutorial();
    // }, 500);
    ONE3D.addKit(pack.pack_mesh_code, {
      callback: () => {
        this.events.publish('events', { accessoryLoadingComplete: null });

        this.events.publish('events', {
          resetToDefault: null,
        });
      },
    });
  }
  removePack(pack) {
    // setTimeout(() => {
    //   window.removecameratutorial();
    // }, 500);
    var status = ONE3D.removeKit(pack.pack_mesh_code);

    if (status == false) {
      if (pack.accessoriesList) {
        for (let index = 0; index < pack.accessoriesList.length; index++) {
          if (pack.accessoriesList[index].mesh_code) {
            ONE3D.removeAccessories(
              pack.accessoriesList[index].mesh_code,
              null
            );
          }
        }
      } else {
        let kits = this.globalService.addedAccessoriesPacks.filter((kit) => {
          return kit.pack_mesh_code == pack.pack_mesh_code;
        })[0];
        for (let index = 0; index < kits.accessoriesList.length; index++) {
          if (kits.accessoriesList[index].mesh_code) {
            ONE3D.removeAccessories(
              kits.accessoriesList[index].mesh_code,
              null
            );
          }
        }
      }
    }
  }
  view3DAccessory(accessory) {
    // setTimeout(() => {
    //   window.removecameratutorial();
    // }, 500);
    this.events.publish('events', { accessoryLoading: null });

    if (this.showImageAccessory) {
      this.showImageAccessory = false;
    }
    this.globalService.imageAccessoryOpen = false;

    ONE3D.setAccessorieCamera(accessory.hotspot_name, null, {
      callback: () => {
        this.events.publish('events', { accessoryLoadingComplete: null });
        this.cameraSetToAccessory = true;
      },
    });
  }
  removeAccessory(accessory, fromSummary?) {
    // setTimeout(() => {
    //   window.removecameratutorial();
    // }, 500);

    // if removing accessory from summary, then don't show acc view again, directly remove it
    // else remove acc after setting acc view, showing view 360 icon (removing from acc panel)
    if (fromSummary) {
      ONE3D.removeAccessories(accessory.mesh_code, null);
    } else {
      this.events.publish('events', { accessoryLoading: null });

      if (this.showImageAccessory) {
        this.showImageAccessory = false;
      }
      ONE3D.setAccessorieCamera(accessory.hotspot_name, null, {
        callback: () => {
          this.cameraSetToAccessory = true;
          this.events.publish('events', { accessoryLoadingComplete: null });
          ONE3D.removeAccessories(accessory.mesh_code, null, {
            callback: () => {},
          });
        },
      });
    }
  }
  removeAccessoryForPackOverlap(accessory) {
    if (this.showImageAccessory) {
      this.showImageAccessory = false;
    }
    ONE3D.removeAccessories(accessory.mesh_code, null);
  }
  addImageAccessory(accessory) {
    // if (window.untouched == true) {
    //   window.removecameratutorial();
    // }
    this.events.publish('events', { accessoryLoading: null });
    if (this.globalService.viewInterior) {
      ONE3D.exitAccessoriesView('Interior');
    } else {
      ONE3D.exitAccessoriesView('Exterior');
    }
    this.showImageAccessory = true;
    this.imageLoaded = false;
    this.globalService.imageAccessoryOpen = true;
    this.accessoryImageUrl = accessory.image_url
      ? accessory.image_url
      : 'assets/img/one3d-acc-image.png';
  }
  imageLoadCompleted() {
    this.imageLoaded = true;
    setTimeout(() => {
      this.events.publish('events', { accessoryLoadingComplete: null });
    }, 1000);
  }
  removeImageAccessory(accessory) {
    this.imageLoaded = false;
    this.showImageAccessory = false;
    this.globalService.imageAccessoryOpen = false;
    this.accessoryImageUrl = null;
    this.events.publish('events', { resetToDefault: null });
  }
  closeImagePopup() {
    if (this.globalService.imageAccessoryOpen) {
      this.imageLoaded = false;
      this.showImageAccessory = false;
      this.globalService.imageAccessoryOpen = false;
      this.accessoryImageUrl = null;
    }
  }
  async playFeatures(mesh) {
    const modal = await this.modalController.create({
      component: FeatureShowcaseComponent,
      componentProps: {
        featureMesh: mesh,
      },
      cssClass: 'one3d-sidePanelModal',
      backdropDismiss: false,
      animated: false,
    });
    await modal.present();
    this.events.publish('events', { accessoryHideTutorial: true });
    this.renderer.addClass(document.body, 'one3d-features-mobile-reel-view');
  }

  async loadOldConfiguration(selectedVariant) {
    let defaultPackLoaded = this.getDefaultPack(selectedVariant);
    let meshCodes = this.getAddedMesh(selectedVariant);

    this.widgetService.showLoader();
    ONE3D.changeVariant(selectedVariant.variant_3d_code, {
      callback: (e) => {
        this.variantLoadComplete(selectedVariant);
        this.events.publish('events', { resetToDefault: null });
      },
      showFeature: true,
      showFeatureHp: true,
      preConfig: meshCodes,
      pack: defaultPackLoaded ? defaultPackLoaded : null,
    });
  }
  quickSunroofClose() {
    ONE3D.event
      .getScene()
      .getAnimationGroupByName('JEEP_MERIDIAN_EX_OPTION_SUNROOF_OPEN')
      .stop();
    ONE3D.event
      .getScene()
      .getAnimationGroupByName(
        'JEEP_MERIDIAN_EX_OPTION_SUNROOF_CLOSE'
      ).speedRatio = 50;
    ONE3D.event
      .getScene()
      .getAnimationGroupByName('JEEP_MERIDIAN_EX_OPTION_SUNROOF_CLOSE')
      .play();
    window.closedsunroofquickly = true;
    window.sunroofopen = false;
  }

  quickDoorClose() {
    window.closedoorsquickly();
    ONE3D.event.update();
  }
  async injectAssetsToDOM(data) {
    const model = await this.cachingService.getDataFromSession('modelSelected');
    const url = `${this.pathToAssets}${model.function_js_path}${environment.function_js}`;

    const previous = document.getElementById('carF');
    if (previous) {
      previous.remove();
    }
    const s = document.createElement('script');
    s.type = 'text/javascript';
    s.id = 'carF';
    s.async = true;
    s.src = url;
    document.body.appendChild(s);
    s.onload = () => {
      if (ONE3D != undefined) {
        data['model_name'] = model.model_code;
        this.load3d(data);
      } else {
        alert('One3D Not Found!');
      }
    };
  }
  clearCanvas() {
    // window.clearMemory();
    if (typeof ONE3D != 'undefined') {
      const scene = ONE3D.event.getScene();
      scene.dispose();
    }
    document.querySelector('#one3d').remove();
    let one3dDiv = document.createElement('div');
    one3dDiv.setAttribute('id', 'one3d');
    document.querySelector('#one3dContainer').appendChild(one3dDiv);
  }

  getDefaultPack(variant_details) {
    let defaultPackLoaded;

    variant_details?.packages.forEach((pack) => {
      if (pack.is_default == 'yes') {
        defaultPackLoaded = pack;
      }
    });

    if (
      defaultPackLoaded &&
      !this.globalService.addedAccessoriesPacks.find(
        (pack) => pack.pack_mesh_code == defaultPackLoaded.pack_mesh_code
      )
    ) {
      this.addDefaultPack(defaultPackLoaded);
    }

    return defaultPackLoaded ? defaultPackLoaded.pack_mesh_code : null;
  }

  addDefaultPack(pack) {
    // if (window.location.pathname.includes('visualizer')) return;
    let addPack = {
      pack_id: pack.pack_id,
      accessory_type: 'Package',
      packageName: pack.packageName,
      pack_price: pack.pack_price,
      quantity: 1,
      accessoriesList: pack.accessoriesList,
      pack_mesh_code: pack.pack_mesh_code,
      hotspot_name: pack.hotspot_name,
      is_3d: pack.is_3d,
      is_default: pack.is_default,
      mesh_code: pack.mesh_code,
      tag_name: pack.tag_name,
    };
    this.globalService.addedAccessoriesPacks.push(addPack);
    this.globalService.setConfigData();
    // .then((res) => {
    //   this.globalService.saveConfiguration('update');
    // });

    this.apiService.logGAEvent(
      'uaevent',
      'Content',
      'Click::Accessories',
      'Package ' + pack.packageName
    );
    this.apiService.sendReportingData({
      eName: 'click',
      eCat: 'accessorize_menu',
      eAct: 'kits_add',
      eVal: pack.packageName,
    });
  }

  trimLoadComplete() {
    if (this.globalService.configurator) {
      setTimeout(() => {
        if (ONE3D && ONE3D.toggleHotspot && typeof ONE3D.toggleHotspot === 'function') {
          ONE3D.toggleHotspot(false);
          }
      }, 100);
    } else {
      // on trim change complete, if visualizer then hide only accessories added, not default pack acc
      let meshCodes = this.globalService.selectedVariant.default_pack?.length
        ? this.globalService.selectedVariant.default_pack
        : [];
      ONE3D.hideAddedAccessories({ excludes: meshCodes }); // hide added accessories
    }
    this.events.publish('events', { selectedTrimComplete: null });
  }

  onCanVideoPlay(one3d_video: any) {
    this.isFeatureLoading = false;
    one3d_video.play().catch(error => console.log('One3D video play error:', error));
  }

  onImageLoad() {
    this.isFeatureLoading = false;
  }
}
